import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useAuth } from '../../context/AuthContext';

export default function AuthCallback() {
    const [searchParams] = useSearchParams();
    const { login } = useAuth();

    useEffect(() => {
        const accessToken = searchParams.get('access_token');
        const refreshToken = searchParams.get('refresh_token');

        if (accessToken) {
            login(accessToken, refreshToken);
        }
    }, [searchParams]);

    return <>Autenticando...</>;
}
